"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LeadGenFormModal;
exports.pushToGoogleAnalytics = pushToGoogleAnalytics;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _modal = _interopRequireDefault(require("@ux/modal"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _leadGenForm = _interopRequireDefault(require("./lead-gen-form"));
var _leadGenSuccess = _interopRequireDefault(require("./lead-gen-success"));
var _baseActions = _interopRequireDefault(require("../actions/base-actions"));
var _inputBar = _interopRequireDefault(require("@site/pattern-library-core/input-bar"));
var _domainSearch = _interopRequireDefault(require("@site/pattern-library-core/domain-search"));
var _videoSection = _interopRequireDefault(require("../../../page-body/media-components/video-section"));
var _FormGroupField = _interopRequireDefault(require("../form-group/FormGroupField"));
var _disclaimer = _interopRequireDefault(require("../../../page-body/other/disclaimer"));
var _react2 = require("@linaria/react");
var _image = require("@site/pattern-library-core/image");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const chatWidgetZIndex = 108000;
function pushToGoogleAnalytics() {
  if (global._analyticsDataLayer) {
    global._analyticsDataLayer.push(arguments);
  }
}
const DisclaimerContainer = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "DisclaimerContainer",
  class: "pl-daokake"
});
const UxModal = /*#__PURE__*/(0, _react2.styled)(_modal.default)({
  name: "UxModal",
  class: "pl-u1bkox17"
});

/**
 * LeadGenFormModal Component
 *
 * @param {String} eid EID data is utilized for tracking; it is consumed via
 * Tableau Reports and Promotion data via Google Analytics Reports
 * @param {String} size CTA size
 * @param {String} text Text rendered on the button
 * @param {String} _name Utilized for click-through tracking; only accepts alphanumeric string and underscores
 * @param {String} width CTA width
 * @param {String} design CTA design
 * @param {Array} fields The form fields to collect from the user, links to a lead gen form field
 * @param {String} ajaxUrl The API endpoint to post the form payload, should be LMAPI to post to Salesforce
 * @param {String} heading The title text rendered on the form modal
 * @param {Function} onClose Function to run on modal close. Return value of success to indicate
 * if the form was submitted successfully.
 * @param {Boolean} complete Form completion status
 * @param {Boolean} disabled Form interactability/mutability
 * @param {Boolean} inverted Invert the colors
 * @param {String} shrinkOn CTA shrink on breakpoint
 * @param {String} leadType Deprecated with pipedrive, do not use
 * @param {String} ariaLabel The HTML aria label used for the button to comply with a11y standards
 * @param {String} errorText The descriptive error text rendered on the modal
 * @param {Boolean} modalOpen When set it will automatically open the form
 * modal on page load; unset will require the user to click the button to open it
 * @param {Array} questions Today we only use this selector field to add the annual sales dropdown field to the form
 * @param {Boolean} hideButton Flag to hide CTA
 * @param {Array} leadFilter Deprecated with pipedrive, do not use
 * @param {String} subheading The descriptive text rendered below the title text on the form modal
 * @param {Object} disclaimer An item containing the disclaimer text that renders at the bottom of the form modal
 * @param {Object} modalHeader The asset rendered above the title text on the form modal
 * @param {String} payMeNumber The contact number rendered immediately after the subheading
 * @param {String} productIntent Routes the lead to the correct Salesforce instance
 * @param {String} leadSource A descriptive label used for first-level sorting/catgeorization in Salesforce
 * @param {String} leadName A descriptive label for the lead to assist with sorting in Salesforce
 * @param {String} campaignId The unique numeric ID in ad platforms (e.g. Meta, Google, etc) associated with a campaign
 * @param {String} campaignName  A descriptive label for a campaign, primarily useful for campaign management
 * @param {Object} dealPipedriveIds Deprecated with pipedrive, do not use
 * @param {Object} personPipedriveIds Deprecated with pipedrive, do not use
 * @param {Object} pipedriveDataFields Deprecated with pipedrive, do not use
 * @param {Object} successModal The submission screen presented to the user upon successful submission
 * @param {Object} annualSalesTracking Binds tracking to the form submission for certain annual sales
 * @returns {React.ReactElement} LeadGenFormModal Component
 * @public
 */
// eslint-disable-next-line complexity
function LeadGenFormModal({
  id,
  eid,
  size = 'small',
  text,
  _name,
  width = 'auto',
  design = 'primary',
  fields,
  ajaxUrl,
  heading,
  onClose = () => {},
  complete = false,
  disabled,
  inverted = false,
  partial,
  shrinkOn,
  leadType,
  ariaLabel,
  errorText,
  modalOpen = false,
  questions,
  hideButton = false,
  leadFilter = [],
  subheading,
  disclaimer,
  modalHeader,
  payMeNumber,
  productIntent,
  leadSource,
  leadName,
  campaignId,
  campaignName,
  dealPipedriveIds,
  personPipedriveIds,
  pipedriveDataFields,
  successModal: defaultSuccessModal,
  annualSalesTracking = [],
  ...modalProps
}) {
  const [visible, setVisibility] = (0, _react.useState)(modalOpen);
  const [successModal, setSuccessModal] = (0, _react.useState)(complete && defaultSuccessModal);
  const [expectedSignedaGPV, setExpectedSignedaGPV] = (0, _react.useState)('0.0');
  const {
    byActionText,
    agreement,
    privacyPolicy,
    url,
    ...disclaimerData
  } = disclaimer || {};
  const {
    image,
    header,
    closeText,
    subHeading,
    video,
    ctas,
    helpfulLinks
  } = successModal || {};
  (0, _react.useEffect)(() => {
    if (modalOpen && !visible) {
      setVisibility(modalOpen);
    }
  }, [modalOpen]);
  const handleButtonClick = event => {
    event?.preventDefault && event.preventDefault();
    setVisibility(!visible);
  };
  const handleClose = () => {
    const success = successModal !== false;
    setVisibility(false);
    setSuccessModal(complete);
    onClose({
      success: success
    });
  };
  const getLeadFilterData = (data, filters = leadFilter) => {
    for (let i = 0; i < filters.length; i++) {
      let isValid = false;
      const {
        fieldName,
        regexp,
        options
      } = filters[i];
      if (options) {
        isValid = options.some(option => option.value === data[fieldName]);
      } else if (regexp) {
        isValid = new RegExp(regexp).test(data[fieldName]);
      }
      if (isValid) {
        return filters[i];
      }
    }
  };
  const getExpectedSignedaGPV = data => {
    if (!leadFilter) {
      return '0.0';
    }
    const matched = getLeadFilterData(data);
    if (!matched) {
      return '0.0';
    }
    const matchedOption = matched.options?.find(option => {
      return option.value === data[matched?.fieldName];
    });
    return matchedOption?.expectedSignedaGPV || '0.0';
  };
  const handleSuccess = data => {
    const leadFilterData = getLeadFilterData(data) || {};
    setSuccessModal(leadFilterData.successModal || defaultSuccessModal);
    setExpectedSignedaGPV(getExpectedSignedaGPV(data));
  };
  function handleError() {
    setSuccessModal(false);
  }
  function handleSubmit(data) {
    const {
      annualsales
    } = data;
    const leadFilterData = getLeadFilterData(data);
    const trackingValues = annualSalesTracking?.map(item => item.value);
    if (leadType?.leadType === 'Payments' && trackingValues.includes(annualsales)) {
      pushToGoogleAnalytics('event', 'conversion', {
        send_to: 'AW-1069554140/NobECODn7agDENyzgP4D'
      });
    }
    return {
      sendRequest: (leadFilterData && Boolean(leadFilterData.sendRequest)) ?? true
    };
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !hideButton && /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    id: id,
    _name: _name,
    text: text,
    size: size,
    width: width,
    design: design,
    "data-cy": "lead-gen-form-button",
    onClick: handleButtonClick,
    "data-eid": eid,
    disabled: disabled,
    partial: partial || (inverted ? 'dark1' : ''),
    "aria-label": ariaLabel,
    shrinkOn: shrinkOn
  }), visible && /*#__PURE__*/_react.default.createElement(UxModal, (0, _extends2.default)({
    id: id,
    onClose: handleClose,
    focusLock: false
  }, modalProps), /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.ModalPatch, {
    maxKnownZIndex: chatWidgetZIndex
  }), successModal ? /*#__PURE__*/_react.default.createElement(_leadGenSuccess.default, {
    onClose: handleClose,
    leadType: leadType,
    productIntent: productIntent,
    payMeNumber: payMeNumber,
    modalHeader: modalHeader,
    successImage: image,
    successHeader: header,
    helpfulLinks: helpfulLinks,
    successCloseText: closeText,
    successSubHeading: subHeading,
    successVideo: video,
    expectedSignedaGPV: expectedSignedaGPV,
    ctas: ctas
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_leadGenForm.default, {
    text: text,
    _name: _name,
    width: width,
    fields: fields,
    ajaxUrl: ajaxUrl,
    heading: heading,
    onError: handleError,
    leadType: leadType,
    onSubmit: handleSubmit,
    errorText: errorText,
    onSuccess: handleSuccess,
    questions: questions,
    subheading: subheading,
    modalHeader: modalHeader,
    payMeNumber: payMeNumber,
    productIntent: productIntent,
    leadSource: leadSource,
    leadName: leadName,
    campaignId: campaignId,
    campaignName: campaignName,
    dealPipedriveIds: dealPipedriveIds,
    personPipedriveIds: personPipedriveIds,
    pipedriveDataFields: pipedriveDataFields
  }), byActionText && agreement && privacyPolicy && url && /*#__PURE__*/_react.default.createElement(DisclaimerContainer, {
    "data-cy": "disclaimer-modal-container"
  }, `${byActionText}, ${agreement} `, /*#__PURE__*/_react.default.createElement(_disclaimer.default, (0, _extends2.default)({}, disclaimerData, {
    text: privacyPolicy,
    href: url
  })), "."))));
}
const successModalPropType = _propTypes.default.shape({
  image: _propTypes.default.shape(_image.imgPropShape),
  header: _propTypes.default.string,
  closeText: _propTypes.default.string,
  subHeading: _propTypes.default.string,
  video: _propTypes.default.shape(_videoSection.default.propTypes),
  ctas: _propTypes.default.oneOfType([_propTypes.default.instanceOf(_baseActions.default), _propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.shape(_merchButton.NSMerchButton.propTypes), _propTypes.default.shape(_inputBar.default.propTypes), _propTypes.default.shape(_domainSearch.default.propTypes)]))]),
  helpfulLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string,
    ariaLabel: _propTypes.default.string,
    href: _propTypes.default.string,
    width: _propTypes.default.string,
    size: _propTypes.default.string,
    design: _propTypes.default.string,
    id: _propTypes.default.string
  }))
});
LeadGenFormModal.propTypes = {
  eid: _propTypes.default.string,
  text: _propTypes.default.string,
  userId: _propTypes.default.string,
  size: _propTypes.default.oneOf(['small', 'default']),
  width: _propTypes.default.oneOf(['auto', 'full']),
  shrinkOn: _propTypes.default.oneOf(['mobile', 'tablet']),
  _name: _propTypes.default.string,
  design: _propTypes.default.oneOf(['inline', 'primary', 'secondary']),
  fields: _propTypes.default.arrayOf(_propTypes.default.shape(_FormGroupField.default.propTypes)),
  ajaxUrl: _propTypes.default.shape({
    Value: _propTypes.default.string
  }),
  onClose: _propTypes.default.func,
  heading: _propTypes.default.string.isRequired,
  complete: _propTypes.default.bool,
  inverted: _propTypes.default.bool,
  partial: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  leadType: _propTypes.default.shape({
    leadType: _propTypes.default.string,
    pipeline: _propTypes.default.string,
    pipelineId: _propTypes.default.string,
    defaultTitle: _propTypes.default.string,
    pipedriveInstance: _propTypes.default.string,
    createOrg: _propTypes.default.bool,
    pipedriveUserId: _propTypes.default.string
  }),
  errorText: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  modalOpen: _propTypes.default.bool,
  disclaimer: _propTypes.default.shape(_disclaimer.default.propTypes),
  questions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    required: _propTypes.default.bool,
    items: _propTypes.default.arrayOf(_propTypes.default.shape({
      text: _propTypes.default.string,
      value: _propTypes.default.string,
      id: _propTypes.default.string,
      _name: _propTypes.default.string,
      templateName: _propTypes.default.string
    })),
    pipedriveDealField: _propTypes.default.bool,
    pipedrivePersonField: _propTypes.default.bool,
    pipedriveFieldId: _propTypes.default.string,
    placeholder: _propTypes.default.string,
    id: _propTypes.default.string,
    name: _propTypes.default.string,
    _name: _propTypes.default.string,
    templateName: _propTypes.default.string
  })),
  hideButton: _propTypes.default.bool,
  subheading: _propTypes.default.string.isRequired,
  modalHeader: _propTypes.default.shape(_image.imgPropShape),
  leadFilter: _propTypes.default.arrayOf(_propTypes.default.shape({
    successModal: successModalPropType,
    regexp: _propTypes.default.string,
    sendRequest: _propTypes.default.bool,
    fieldName: _propTypes.default.string,
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      value: _propTypes.default.string,
      expectedSignedaGPV: _propTypes.default.string
    })),
    id: _propTypes.default.string,
    _name: _propTypes.default.string,
    templateName: _propTypes.default.string
  })),
  payMeNumber: _propTypes.default.string,
  successModal: successModalPropType,
  annualSalesTracking: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string,
    value: _propTypes.default.string,
    id: _propTypes.default.string,
    _name: _propTypes.default.string,
    templateName: _propTypes.default.string
  })),
  productIntent: _propTypes.default.object,
  leadSource: _propTypes.default.object,
  campaignId: _propTypes.default.string,
  campaignName: _propTypes.default.string,
  leadName: _propTypes.default.string,
  dealPipedriveIds: _propTypes.default.shape({
    MarketId: _propTypes.default.string,
    PrivateLabelId: _propTypes.default.string,
    VisitorId: _propTypes.default.string,
    CustomerId: _propTypes.default.string,
    id: _propTypes.default.string,
    _name: _propTypes.default.string,
    templateName: _propTypes.default.string
  }),
  personPipedriveIds: _propTypes.default.shape({
    CustomerId: _propTypes.default.string,
    id: _propTypes.default.string,
    _name: _propTypes.default.string,
    templateName: _propTypes.default.string
  }),
  pipedriveDataFields: _propTypes.default.object,
  ..._modal.default.propTypes
};